module.exports = __webpack_public_path__ + "img/weingutloewenstein_7.f434188d.jpg";